<template>
  <div>
    <FilterOrganization :disable="true" @option="onOptionChange" :option="option"/>
<!--    <ReportCompetency class="mb-4" />-->

    <RAssessmentControl class="mb-4" />
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import FilterOrganization from "@/projects/components/Filter/FilterOrganization.vue";
import ReportCompetency from "@/projects/views/E-Performances/Dashboard/Admin/components/ReportCompetency.vue";
import RAssessmentControl from "@/projects/views/E-Performances/Reports/assessment/components/index.vue";


export default {
  name: "RAssessment",
  components: {RAssessmentControl, FilterOrganization, ReportCompetency },

  props: {

    item:{
      type: Array,
      default() {
        return []
      }
    },
    fields: {
      type: Array,
      default() {
        return [
          {key:"index", label: "#",  _style: 'width:50px; text-align: center'},
          {key:"code", label:"Code", _style: 'width:30px; text-align: center'},
          {key:"accounts", label:"Name"},

          {key:"level", label:"level"},

          {key:"assessor1", label:"Assessor 1"},
          {key:"assessor2", label:"Assessor 2"},
          {key:"status", label:"Status"},
        ]
      }
    },
    type: {
      type: String,
      default: 'cil-user'
    },
    hover: Boolean,
    striped: Boolean,
    bordered: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean,

    isHris: {
      type: Boolean,
      default: true
    },
    pages:{
      type: Object,
      default() {
        return {
          values:[10,20,50,100]
        }
      }
    },
    loading:{
      type: Boolean,
      default() {
        return false
      }
    },

    disable: {
      type: Boolean,
      default() {
        return false
      }
    }

  },
  data: function () {
    return {
      option:{
        organization: "66cbe802a41ed9362a8579fa",
        agency: 0,
        year: new Date().getFullYear() + 543,
      },
      retportsAssessment:[]
    }

  },

  mounted () {
  },

  created () {
    this.onInit()

  },
  beforeDestroy () {

  },

  methods: {
    onInit(){
      this.onLoad();
      var body = {};
      this.$store.dispatch("report/config",body)
    },

    onLoad(){

    },

    onOptionChange(e){
      this.option = e;
    },


  },

  computed:{
    ...mapGetters({
      lang : "setting/lang",
      retports : "report/item"
    }),

  },

  watch: {
    lang(value){

    },

    retports(value){
      console.log(value)
      this.retportsAssessment = value.filter(item => {

        try {
          if(item.status.assessor2.state._id !== "654851ece41b7f46025977fa" ){
            item.message = item.assessor2 +" : "+item.status.assessor2.state.title.filter(item => { return item.key === lang })[0].value
          }
        }catch (e) {

        }

        try {
          if(item.status.assessor1.state._id !== "654851ece41b7f46025977fa" ){
            item.message = item.assessor1 +" : "+item.status.assessor1.state.title.filter(item => { return item.key === lang })[0].value
          }
        }catch (e) {

        }

        if(item.status.yourself.state._id !== "654851ece41b7f46025977fa" ){
          item.message = item.yourself +" : "+item.status.yourself.state.title.filter(item => { return item.key === lang })[0].value
        }

        console.log(item)
        return item
      })


    }
  }

}
</script>

<style scoped>

</style>
